import { Injectable, signal } from '@angular/core';
import { SchemaProvider } from '../../constants/shema-provider';
import { EncoderService } from '../encoder/encoder.service';
import { defaultLitmusConversation } from '../../constants/default-litmus-conversation';
import { UtilsService } from '../utils/utils.service';
import { SettingsService } from '../settings';
import * as _ from 'lodash'
import { environment } from 'src/environments/environment';
import { ltmsConversationDefaultProps } from 'src/app/features/projects/settings/project-interaction-settings-home/constants/default';

@Injectable({
  providedIn: 'root'
})
export class ConversationService {
  conversationObject: any = signal({
    configuration: {},
    question: {},
    brand_detail: {},

  });
  configuration: any = {};
  question: any = {}
  default_language: string = 'english'
  language: string = ''
  selectedId: any = null
  fieldsHash: any = {}
  defaultConversation = {};
  brand_detail: any = {}
  labelsRetrieved: boolean = false;
  currentHeaderText: string = ''
  cssUrl: any = null;
  jsUrl: any = null;
  devices: any = ["phone", "desktop", "tablet"];
  default_device: any = 'phone';
  previewDevice: string = 'phone';
  reactorComponents: any = ["ltms-rating-bubble-reactor", "ltms-rating-bar-reactor", "ltms-rating-text-reactor", "ltms-rating-color-reactor"];
  multiOptionsList = {};
  multiSelectModel = {};
  configurationLoaded: boolean = false;
  defaultLitmusConversation: any = {};
  sections: any = null;
  lastSelectedInteractionId: any = null;
  componentsHash: any = {};
  savingAdvanceSettings: boolean = false;
  conversationPublishing: boolean = false;
  interactionSaving: boolean = false;
  conversationSaving: boolean = false;

  isSaveEnabled = false;

  customConfig: any = {
    css: [],
    javascript: [],
    googleAnalyticsCode: ""
  };

  customConfigUrl: any = {
    css: [],
    javascript: []
  };

  tempFileObjects: any = [];
  disable_copy: boolean = true;
  selectedLanguage: any = {};
  brandId: any = null;
  is_tour_enabled: boolean = true;
  files: any = {};
  props_to_delete: any = ltmsConversationDefaultProps.props_to_delete || [];
  configData: any = []
  constructor(
    private _encoderService: EncoderService,
    private _utils: UtilsService,
    private _settingsService: SettingsService
  ) { }

  init(brandDetail: any, brandConfiguration: any) {
    return new Promise((resolve) => {

      if (!_.isEmpty(brandDetail)) {
        this.brand_detail = brandDetail;
        this.disable_copy = _.get(this.brand_detail, "current_configuration.disable_copy");
        this.configData['created_by'] = _.get(Helpers, 'managerDetails.manager._id');
        this.configData['created_by_email_address'] = _.get(Helpers, 'managerDetails.manager.email_address');
        if (!_.isEmpty(brandConfiguration)) {
          this.configData['reference_version'] = _.get(brandConfiguration, 'version', '')
          this.defaultConversation = {}
          this.configuration = brandConfiguration;

          if (this.brand_detail && Helpers.hasProperty(this.brand_detail, "conversation_config.feedbacks.expiration_delay")) {
            this.configuration['expiration_delay'] = this.brand_detail.conversation_config.feedbacks.expiration_delay;
          }
          if (this.brand_detail && Helpers.hasProperty(this.brand_detail, "conversation_config.feedbacks.session_expiry")) {
            this.configuration['session_expiry'] = this.brand_detail.conversation_config.feedbacks.session_expiry;
          }

          if ((!this.configuration.languages_order || this.configuration.languages_order.length === 0) && this.configuration.languages && _.keys(this.configuration.languages).length) {
            this.configuration['languages_order'] = [];
            for (var key in this.configuration.languages) {
              if (Helpers.hasProperty(this.configuration.languages, key)) {
                this.configuration['languages_order'].push(key)
              }
            }
            // this.configuration.languages_order = languages_order;
          }
          if (this.configuration && this.configuration.header && this.configuration.header.headerTitle) {
            this.currentHeaderText = this.configuration.header.headerTitle;
          }
          if (this.configuration.is_new_component_editor) {
            // setting default language from configuration 
            this.default_language = this.configuration.default_language;
            if (!this.default_language) {
              this.default_language = 'english';
            }
            this.language = this.default_language;
            this.labelsRetrieved = true;
            this.createHashForFields(this.configuration.fields);
            this.setPageSequence();
            this.setHeaderText();
            this.setDefaultBackLabelId();
            if (this.configuration.fields && this.configuration.fields.length > 0) {
              //this.getInteractionDetail(lastSelectedInteractionId ? lastSelectedInteractionId : this.configuration.fields[0].field_id);
              if (!this.configuration.footer_style) {
                this.configuration.footer_style = {
                  "is_per_group": true
                }
              }
            }
            if (this.configuration.custom_styles && this.configuration.custom_styles.length > 0)
              this.cssUrl = this.configuration.custom_styles[0];
            if (this.configuration.custom_scripts && this.configuration.custom_scripts.length > 0)
              this.jsUrl = this.configuration.custom_scripts[0];
          } else {
            Helpers.showConfirmationBox({
              title: "Create New Interactions",
              content: "This version of Interaction can not be modify, Want to create new?",
              buttons: '[No][Yes]'
            }, (ButtonPressed) => {
              if (ButtonPressed === "Yes") {
                this.setDefaults();
              }
            });
          }
        } else {
          this.setDefaults();
          // If there is no interactions and interactions not yet published then initialize defaultConversation with interaction which consist of Thank you page, link expired page and archive page
          if (!Helpers.hasProperty(this, "brand_detail.current_configuration.100")) {
            if (!_.isEmpty(defaultLitmusConversation)) {
              // Update defaultConversation only at the time of first interaction creation.
              this.defaultConversation = Helpers.deepClone(defaultLitmusConversation);
            }
          }
        }
        this.configurationLoaded = true;

        this.sections = this.handleProperties();
        this.prepareLinkedOptionFields(this.configuration.fields)
        this.conversationObject.update(current => ({ ...current, brand_detail: this.brand_detail, configuration: this.configuration }));
        // conversationGuidedTour();
      }
      this.conversationObject.update(current => ({ ...current, brand_detail: brandDetail, configuration: this.configuration }));

      resolve(true)
    })

  }

  questionTypesMap: any = {};

  createHashForComponent(components) {
    this.questionTypesMap = {};
    this.componentsHash = {};
    _.each(components, (component: any) => {
      if (component.display_on != 'settings' && component._id != "5a0c13dfd46302662b2c8eb8") {
        this.componentsHash[component._id] = component;
        const { category, label } = this.getComponentCategory(component);

        if (!this.questionTypesMap[category]) {

          this.questionTypesMap[category] = {
            name: label,
            type: category,
            components: []
          }
        }
        component.category = category;
        this.questionTypesMap[category].components.push(component)

      }

    })
  }

  getComponentCategory(component: any) {
    let category: any = component.type || 'others';
    let label: any = component.type || 'Others'
    if (component.name == "ltms-cookie-counter-token" || component.name == "ltms-cookie-counter") {
      category = 'others'
      label = 'Others'
    } else if (category == "rating") {
      if (component.main_rater_type == 3 || component.main_rater_type == '3') {
        category = 'nps',
          label = 'NPS'

      } else if (component.name == "ltms-six-pill-rater" || component.name == "ltms-three-point-wheel") {
        category = 'six-scale'
        label = '6 Scale'
      } else if (component.name == "ltms-four-pill-rater") {
        category = 'four-scale'
        label = '4 Scale'
      } else if (component.name == 'ltms-detailed-slider') {
        category = 'slider'
        label = 'Slider'

      } else if (component.scale_rater_type == "5" || component.scale_rater_type == 5) {
        category = 'five-scale'
        label = '5 Scale'
      } else if (component.scale_rater_type == "-5 to +5" || component.scale_rater_type == "1-10") {
        category = 'ten-scale'
        label = '10 Scale'
      } else {
        label = 'Litmus-rating'
      }
    } else if (component.type == "redirector") {
      category = 'redirector'
      label = 'Redirector'
    } else if (["ltms-file-upload", "ltms-carousel-component", "litmus-image", "ltms-social"].indexOf(component.name) > -1) {
      category = 'media'
      label = 'Media'
    } else if (component.name == 'ltms-social-button') {
      category = 'social';
      label = 'Social'
    } else if (component.type == 'single-select' || component.type == 'multi-select' || component.component_category == 'multi-select') {
      category = 'multi-select'
      label = 'Selection-based'
    } else if (component.type == 'text' || component.type == 'label' || component.type == 'link') {
      category = 'text'
      label = 'Text'
    }
    return { category, label }
  }

  getComponentHash() {
    return Helpers.deepClone(this.componentsHash);
  }

  getComponentTypes() {
    return Helpers.deepClone(this.questionTypesMap);
  }

  _id(elem) {
    return document.getElementById(elem)
  }

  handleProperties() {
    // Changes by Bhunesh - Adding tags to restrict questions access - 16th March 2017
    var dynamic_properties = Helpers.deepClone((_.filter(_.map(this.configuration.fields, (item: any) => item.dynamic_properties), function (property) {
      return property;
    })));
    var dynamicFieldNames = [{
      label: "Access Group",
      value: "access_group"
    }, {
      label: "Question Group",
      value: "question_group"
    }]

    var updatedProperties: any = {};
    var groupProperties: any = [];
    var groupkey: any = 'groupType';


    // All questions will have array of tags so dynamic_properties will be array of array
    // Flattens a nested array (the nesting can be to any depth). If you pass shallow, the array will only be flattened a single level.
    dynamicFieldNames.forEach(function (field) {
      updatedProperties[field.value] = _.uniqBy(_.flatten(_.map(dynamic_properties, (item: any) => {
        return item[field.value]
      }), true), "id");
      updatedProperties[field.value] = _.without(updatedProperties[field.value], undefined, null);
    })
    for (var key in updatedProperties) {
      updatedProperties[key].forEach((item: any) => {
        item[groupkey] = key;
        groupProperties.push(item);
      })
    }
    return groupProperties;
  }

  prepareLinkedOptionFields(config_fields) {
    for (var key in config_fields) {
      var field = config_fields[key];
      if (field.component_type && ((field.component_type === "ltms-multi-check-box" || field.component_type === "ltms-multi-select") || (field.interaction_type === 'multi-select')) && !field.group_id) {
        this.multiSelectModel[field.field_id] = {};
        var uniqueFieldOptions = this.prepareLinkedModel(config_fields, field.field_id);
        this.multiOptionsList[field.field_id] = uniqueFieldOptions;
      }
    }
    var default_options = this.prepareLinkedModel(config_fields, 'default_options');
    this.multiOptionsList['default_options'] = default_options;
  }

  setDefaults() {
    this.getConfiguratorSchema();
    this.setHeaderText();
  }

  getConfiguratorSchema() {
    this.configuration = Helpers.deepClone(SchemaProvider.conversation);
    this.selectedLanguage = this.configuration.languages['english'];
    this.selectedLanguage.key = 'english';
  }

  setHeaderText() {
    var selectedLan = this.default_language;
    if (this.isHeaderExist()) {
      var headerLabelId = this.configuration["header"]["label"];
      var headerLabelValue = this.getLabelById(selectedLan, headerLabelId);
      this.setHeaderTextForInput(headerLabelValue, selectedLan);
    } else {
      this.configuration["header"] = SchemaProvider.conversation.header;
      this.setHeaderTextForInput(null, selectedLan);
    }
  }

  isHeaderExist() {
    return (this.configuration["header"] && this.configuration["header"]["label"]);
  }

  setHeaderTextForInput(value, language) {
    var labelvalue = value;
    setTimeout(() => {
      var elem: any = document.getElementById('questionnaireHeaderText');
      if (!labelvalue) {
        labelvalue = this.brand_detail.name;

      }
      if (elem) {
        elem.value = labelvalue;
      }
      this.setLabelById(language, 'label-header', labelvalue);
    })
  }

  getLabelById(language, labelId) {
    if (labelId && language) {
      var label;
      try {
        label = this.configuration.languages[language.toString()]['labels'][labelId.toString()];
      } catch (e) {

      }
      return label ? label : "";
    }
    return;
  }

  prepareLinkedModel(fields, field_id) {
    var grouped_fields: any = [];
    for (var key in fields) {
      var field = fields[key];
      if (field.component_type && (((field.component_type === "ltms-multi-check-box" || field.component_type === "ltms-multi-select") && (field.group_id && field_id != field.group_id)))) {
        var obj: any = {
          id: field['field_id'],
          label: field['text'],
          group_text: field['group_text']
        };
        grouped_fields.push(obj);
      }
      if (field_id != 'default_options') {
        this.multiSelectModel[field_id][field.field_id] = [];
        if (field && 'linked_field_id' in field && field_id === field.group_id) {
          var linked_field_ids = (typeof field.linked_field_id === 'string') ? [field.linked_field_id] : (field.linked_field_id ? field.linked_field_id : []);
          if (linked_field_ids.length) {
            for (var key2 in linked_field_ids) {
              const field2: any = _.find(fields, { field_id: linked_field_ids[key2] })
              var obj: any = {
                id: linked_field_ids[key2],
                label: field2.text,
                group_text: field2.group_text
              }
              if (!this.multiSelectModel[field_id]) {
                this.multiSelectModel[field_id] = {}
              }
              if (!this.multiSelectModel[field_id][field.field_id]) {
                this.multiSelectModel[field_id][field.field_id] = []
              }
              this.multiSelectModel[field_id][field.field_id].push(obj);
            }
          }
        }
      }

    }
    return grouped_fields;
  }

  setPageSequence() {
    if (this.configuration.screens) {
      _.each(this.devices, (deviceId) => {
        if (this.configuration.screens[deviceId]) {
          var pages = this.configuration.screens[deviceId][this.default_language.toString()];
          var flows = this.configuration.flows[deviceId][this.default_language.toString()];
          if (pages && pages.length > 0) {
            _.each(pages, function (page) {
              var flowIndex = flows.indexOf(page.id) + 1;
              page.currentIndex = flowIndex;
            })
          }
        }
      })
    }
  }

  setDefaultBackLabelId() {
    var deviceId = this.default_device;
    var language = this.default_language;
    var screens = this.configuration["screens"][deviceId.toString()][language];
    // filter pages which are defined on screens
    screens = screens.map((page) => {
      if (page && page.is_rating_page) {
        if (!page.rating_back_button_label) {
          page.rating_back_button_label = this.generateBackButtonLabel();
        }
      }
      return page;
    });
    this.configuration["screens"][deviceId.toString()][language] = screens;
  }

  generateBackButtonLabel() {
    var backButtonText: string = "Back",
      buttonLabelId: any = null,
      existingLabelForText: any = (this.getPropertyNameForText(this.default_language, backButtonText));
    if (!existingLabelForText) {
      buttonLabelId = this.generateId('label') + Helpers.getRandomString();
      this.setLabelById(this.default_language, buttonLabelId, backButtonText);
    } else {
      buttonLabelId = existingLabelForText;
    }
    return buttonLabelId;
  }

  getPropertyNameForText(language, text) {
    var allLabels = this.configuration.languages[language.toString()]['labels'];
    var properyFound: any = null;
    for (var propName in allLabels) {
      var propValue = allLabels[propName];
      if (propValue == text) {
        properyFound = propName;
        break;
      }
    }
    return properyFound;
  }

  generateId(type) {
    return (type.toString() + "_" + (new Date()).getTime()).toString();
  }

  removeSubQuestionsWithGroupId() {
    delete this.question["question_component_type"];
    delete this.question['sub_questions'];
    delete this.question['allowMultiSelect'];
    this.configuration.fields = this.configuration.fields.map((field: any) => {
      if (field.group_id) {
        if (field.group_id == this.question.field_id) {
          field.is_deleted = true;
        }
      }
      return field;
    })
  }

  createHashForFields(fields) {
    //this.fieldsHash = {};
    _.each(fields, (field: any) => {
      this.fieldsHash[field.field_id] = field;
    })
  }

  setLabelById(language, labelId, text) {
    this.configuration.languages[language]['labels'][labelId.toString()] = text;
  }
  removeAllFiles() {
    this.tempFileObjects = [];
  }

  saveConversation(isPublish: boolean, requestFrom?: any) {
    return new Promise((resolve, reject) => {
      // if (isPublish && !Utils.getProp(this, "configuration.expiration_delay")) {
      //     Helpers.smallAlertBox("Error", "Configure Expiry detail", "error", 1500);
      //     return;
      // }

      if (this.configuration && !this.configuration['expiration_delay']) {
        /*Bug fix: taking the expiration delay from the brand details if present. TicketID -LP21121412062                    
        */
        if (this.brand_detail && Helpers.hasProperty(this.brand_detail, "conversation_config.feedbacks.expiration_delay")) {
          this.configuration['expiration_delay'] = this.brand_detail.conversation_config.feedbacks.expiration_delay;
        }
        this.configuration['expiration_delay'] = 5 * 24 * 60 * 60 * 1000;
      }

      if (this.configuration && !this.configuration['session_expiry']) {
        if (this.brand_detail && Helpers.hasProperty(this.brand_detail, "conversation_config.feedbacks.session_expiry")) {
          this.configuration['session_expiry'] = this.brand_detail.conversation_config.feedbacks.session_expiry;
        }
        //set default as 0. In the rendering engine side we are parsing and checking for more than 0 value. Hence default value as 0 will not crate an issue.
        this.configuration['session_expiry'] = 0;
      }

      this.saveConfiguration(isPublish).then((response: any) => {
        this.uploadAllFiles(requestFrom).then((result: any) => {
          // this.removeAllFiles()

          if (this.configuration && this.configuration.header && this.configuration.header.headerTitle == "Provide label for header") {
            this.configuration.header.headerTitle = this.brand_detail.name;
          }

          if (result && result.length) {
            _.each(result, (res: any) => {
              const publicUrl = _.get(res, 'data.data.public_logo_url');
              const type = _.get(res, 'type');
              this.removeFile({id:type});
              if (type && res.data.code == 0 && publicUrl) {
                if (type == 'header') {
                  this.configuration[type].headerLogoUrl = publicUrl
                }
                if (type == 'footer') {
                  this.configuration[type].footerLogoUrl = publicUrl
                }
              }
            })
          }
          setTimeout(() => {
            this.conversationPublishing = false;
            var textChangeMessage = "Please update the Header text for all your configured languages in the respective language script, on the Language tab.<br/>";
            if (response.isPublish) {
              var popupContent = "Are you sure, you want to Save & Publish?";
              if (this.currentHeaderText && this.currentHeaderText !== this.configuration.header.headerTitle) {
                popupContent = textChangeMessage + popupContent;
              }
              Helpers.SmartMessageBox({
                title: "Save & Publish",
                content: popupContent,
                buttons: [{
                  text: "No",
                  type: 'secondary',
                  key: 'No'
                }, {
                  text: "Yes",
                  type: 'primary',
                  key: 'Yes'
                }]
              }, (ButtonPressed) => {
                if (ButtonPressed === "Yes") {
                  this.conversationPublishing = true;
                  this.copyPhoneConfigToOtherDevices(response.isPublish).then(result => {
                    this.saveConverationDesign(response.isPublish, requestFrom).then((response) => {
                      this.currentHeaderText = this.configuration.header.headerTitle;
                      resolve(response);
                    })
                  });
                } else {
                  resolve(true)
                }
              });
            } else {
              var popupContent = "Are you sure, you want to Save?";
              if (this.currentHeaderText && this.currentHeaderText !== this.configuration.header.headerTitle) {
                popupContent = textChangeMessage + popupContent;

                Helpers.SmartMessageBox({
                  title: "Save",
                  content: popupContent,
                  buttons: [{
                    text: "No",
                    type: 'secondary',
                    key: 'No'
                  }, {
                    text: "Yes",
                    type: 'primary',
                    key: 'Yes'
                  }]
                }, (ButtonPressed) => {
                  if (ButtonPressed === "Yes") {
                    this.interactionSaving = true;
                    this.copyPhoneConfigToOtherDevices(response.isPublish).then(result => {
                      this.saveConverationDesign(false, requestFrom).then((response) => {
                        this.currentHeaderText = this.configuration.header.headerTitle;
                        resolve(response);
                      })
                    });
                  } else {
                    resolve(true)
                  }
                });
              } else {
                this.interactionSaving = true;
                this.copyPhoneConfigToOtherDevices(response.isPublish).then(result => {
                  this.saveConverationDesign(false, requestFrom).then((response) => {
                    resolve(response);
                  })
                });
              }
            }
          });
        })
      })
      // $rootScope.$broadcast('event:trigger-custom-upload', {
      //     isPublish: isPublish,
      //     requestFrom: requestFrom
      // });
      // this.conversationPublishing = false;
      // if (isPublish) {
      //     $.SmartMessageBox({
      //         title: "Save & Publish",
      //         content: "Are you sure, you want to Save & Publish?",
      //         buttons: '[No][Yes]'
      //     }, function (ButtonPressed) {
      //         if (ButtonPressed === "Yes") {
      //             this.conversationPublishing = true;
      //             copyPhoneConfigToOtherDevices(isPublish);
      //             saveConverationDesign(isPublish, requestFrom);
      //         }
      //     });
      // } else {
      //     this.interactionSaving = true;
      //     copyPhoneConfigToOtherDevices(isPublish);
      //     saveConverationDesign(false, requestFrom);
      // }
      //  conversationGuidedTour();
    })

  }


  /**
   * copyPhoneConfigToOtherDevices: Copy phone's interaction to all other devices
   * @description : This will copy the interaction only if cnvdr.disable_copy is true and not isPublish
   */
  copyPhoneConfigToOtherDevices(isPublish) {
    return new Promise((resolve: any) => {
      if (this.disable_copy) {
        var deviceToCopyFrom = "phone";
        // loop through all device and copy configuration of phone to all other devices
        let promises: any = [];
        _.each(this.devices, (device) => {
          if (deviceToCopyFrom != device) {
            promises.push(this.copyDisplayConfiguration(deviceToCopyFrom, device));
          }
        });
        Promise.all(promises).then(result => {
          resolve(true);
        });
      } else {
        resolve(true)
      }
    })
  }

  copyDisplayConfiguration(srcConfigDevice, destConfigDevice) {
    return new Promise((resolve: any) => {
      if (srcConfigDevice && destConfigDevice) {
        if (this.disable_copy) {
          this.copyDisplayConfigurationInternal(srcConfigDevice, destConfigDevice);
          resolve(true);
        } else {
          Helpers.showConfirmationBox("Copy Configuration", "Are you sure, you want to copy this configuration?", (answer) => {
            if (answer) {
              this.copyDisplayConfigurationInternal(srcConfigDevice, destConfigDevice);
            }
            resolve(true);
          });
        }
      }
    })
  };

  /**
   * copyDisplayConfiguration: Function to copy display configuration from one device to another
   * @param  {string} srcConfigDevice  :  source device of which configuration needs to copy
   * @param  {string} destConfigDevice :  destination device for which copy needs to be done
   */
  copyDisplayConfigurationInternal(srcConfigDevice, destConfigDevice) {
    if (this.configuration.screens[srcConfigDevice]) {
      var pages = this.configuration.screens[srcConfigDevice][this.default_language.toString()];
      if (pages && pages.length >= 0) {
        // doing deep cloning
        // Changes By Bhunesh - Feb 9th 2017 - Removed redudant codes
        var copiedPages = Helpers.deepClone(pages);
        var copiedConfiguration = {
          "screens": {},
          "flows": {},
          "archive_flows": {},
          "expired_flows": {}
        };
        var language = this.default_language;
        var copiedFlows = _.get(this, "configuration.flows." + srcConfigDevice.toString() + '.' + language);
        var copiedArchivedFlows = _.get(this, "configuration.archive_flows." + srcConfigDevice.toString() + '.' + language);
        var copiedExpiredFlows = _.get(this, "configuration.expired_flows." + srcConfigDevice.toString() + '.' + language);

        copiedConfiguration.screens = copiedPages.map((copiedPage, index) => {
          copiedPage.id = this.generateNewPageId(copiedPage.id, srcConfigDevice, destConfigDevice);
          // setting page title based on selected display config
          if (srcConfigDevice.page_title) {
            copiedPage.page_title = this.replaceString(copiedPage.page_title, srcConfigDevice, destConfigDevice);
          } else {
            // copiedPage.page_title = 'Page-' + parseInt(index + 1) + '-' + destConfigDevice.capitalizeFirstLetter();
            var destConfigDeviceInCamelCase = destConfigDevice.capitalizeFirstLetter();
            var params = {
              "defaultPageTitle": 'Page-' + parseInt(index + 1) + '-' + destConfigDeviceInCamelCase,
              "destConfigDevice": destConfigDeviceInCamelCase,
              "srcDevice": srcConfigDevice
            };
            copiedPage = this.getPageTitle(copiedPage, params);
          }
          return copiedPage;
        });

        if (copiedFlows && copiedFlows.length > 0) {
          copiedConfiguration.flows = copiedFlows.map((copiedPageId) => {
            return this.generateNewPageId(copiedPageId, srcConfigDevice, destConfigDevice);
          });
        }
        if (copiedArchivedFlows && copiedArchivedFlows.length > 0) {
          copiedConfiguration.archive_flows = copiedArchivedFlows.map((copiedPageId) => {
            return this.generateNewPageId(copiedPageId, srcConfigDevice, destConfigDevice);
            // return destConfigDevice.toString() + '_page_' + getNumberFromId(copiedPageId);
          });
        }

        if (copiedExpiredFlows && copiedExpiredFlows.length > 0) {
          copiedConfiguration.expired_flows = copiedExpiredFlows.map((copiedPageId) => {
            return this.generateNewPageId(copiedPageId, srcConfigDevice, destConfigDevice);
            // return destConfigDevice.toString() + '_page_' + getNumberFromId(copiedPageId);
          });
        }
        this.copyConfig.apply(this, [copiedConfiguration, language, destConfigDevice, srcConfigDevice]);

      } else {
        Helpers.smallAlertBox("Error", "No Pages Available to Copy from " + srcConfigDevice.charAt(0).toUpperCase() + srcConfigDevice.slice(1), 'error', 1500);
      }
    }
  }

  // added by Bhunesh - 9th Feb - Added try catch 

  copyConfig(configuration, language, destConfigDevice, srcConfigDevice) {
    try {
      for (var prop in configuration) {
        this.configuration[prop][destConfigDevice][language] = configuration[prop.toString()]
      }
      if (!this.disable_copy)
        Helpers.smallAlertBox("Success", "Copied from " + srcConfigDevice.charAt(0).toUpperCase() + srcConfigDevice.slice(1), "success", 1500);
    } catch (e) {
      console.error("Error: Conversation Service : copyConfig()", e);
      Helpers.smallAlertBox("Error", "Error while copying configuration", "error", 1500);
    }
  }

  // Added to generate new pageId while doing copy config
  generateNewPageId(idStr, src, dest) {
    // match() will give all the digits on idStr
    var pageId = idStr.match(/\d/g);
    if (pageId) {
      pageId = dest.toString() + '_page_' + pageId.join("");
    } else {
      return this.replaceString(idStr, src, dest);
    }
    return pageId;
  }

  replaceString(string, matchString, newString) {
    // using regex for case insensitive replacement
    var regEx = new RegExp(matchString, "ig");
    return string.replace(regEx, newString);
  }

  /**
   * getPageTitle: Method to populate page title
   * @param  {object} page  
   * @param  {object} params: dependent parameter like defaultPageTitle, destConfigDevice, srcDevice
   */
  getPageTitle(page, params) {
    if (page && page.page_title) {
      // Convert srcDevice name into camel case. Eg: phone to Phone, desktop to Desktop etc
      var srcDeviceInCamelCase = params["srcDevice"].capitalizeFirstLetter();

      // Customised page title
      if (page.page_title.toLowerCase().indexOf(params["srcDevice"]) != -1) {
        // Create regular expression for device name in lowercase or device name with first letter as capital
        var regex = new RegExp(params["srcDevice"] + "|" + srcDeviceInCamelCase, "gi");
        // title contains subtext same as srcDevice
        page.page_title = page.page_title.replace(regex, function (matched) {
          return params.destConfigDevice;
        });
      } else {
        // If the page header doesn't source device name and is a customised text then append '-' precessed by device name in camel case
        page.page_title = page.page_title + '-' + params.destConfigDevice;
      }

    } else {
      // If page.page_title is empty, undefined or null then add default Page header along preceded by device name
      page.page_title = params["defaultPageTitle"];
    }
    return page;
  }



  saveConverationDesign(isPublish, requestFrom) {
    return new Promise((resolve, reject) => {
      //Added Validation in Header Logo/Footer Logo 
      var validateLogo = this.validateHeaderFooterLogo();
      if (!validateLogo) {
        return
      }
      if (this.brandId || (this.brand_detail && this.brand_detail._id)) {
        // showLoading(true);
        this.brandId = this.brand_detail._id;
        if (this.files && !_.isEmpty(this.files)) {
          if (this.files['cssFiles'].length > 0) {
            this.configuration['custom_styles'] = this.files['cssFiles'];
            if (_.isEmpty(this.configuration['custom_styles'])) {
              this.configuration['custom_styles'] = [];
            }
          }
          if (this.files['jsFiles'].length > 0) {
            this.configuration['custom_scripts'] = this.files['jsFiles'];
            if (_.isEmpty(this.configuration['custom_scripts'])) {
              this.configuration['custom_scripts'] = [];
            }
          }
        }

        if (!("enable_back_button" in this.configuration)) {
          this.configuration.enable_back_button = true;
        }

        if (requestFrom && requestFrom.includes("Section")) {
          this.handleMultiSelectForGroups();
        }
        this.handleMultiSelectQuestion();
        this.handleBarReactorQuestion();
        this.removeDeletedQuestions();
        this.handlePages(isPublish)

        this.updateLabelsForAllLanguage();

        if (isPublish) {
          var result = this.setInteractionsSequence();
          var message;
          if (result.primary_comment_set && !result.primary_rating_set) {
            message = "Primary Question not set.";
          } else if (!result.primary_comment_set && result.primary_rating_set) {
            message = "Primary Comment not set.";
          } else if (!result.primary_comment_set && !result.primary_rating_set) {
            message = "Primary Comment & Primary Question not set.";
          } else {
            message = null;
          }
          if (message) {
            Helpers.showConfirmationBox("<i class='fa fa-warning text-warning'></i> <span class='text-warning'>Warning</span>", message + " " + "Are you sure, you want to publish?", (answer) => {
              if (answer) {
                this.publishConversation(isPublish, requestFrom).then((response) => {
                  resolve(response);
                })
              } else {
                this.removeAllProgress();
                resolve(false);
              }
            });
          } else {
            this.publishConversation(isPublish, requestFrom).then((response) => {
              resolve(response);
            })
          }
        } else {
          this.publishConversation(isPublish, requestFrom).then((response) => {
            resolve(response);
          })
        }
      }
    })


  }

  setInteractionsSequence() {
    var primaryRatingSet = false;
    var primaryCommentSet = false;
    if (this.configuration.screens) {
      var phonePages;
      try {
        phonePages = this.configuration.screens['phone'][this.default_language.toString()];
        if (phonePages && phonePages.length > 0) {
          var fields = [].concat.apply([], _.map(phonePages, "fields"));
          var questionIndex = 0;
          _.each(fields, (f, index) => {
            if (f && f.field_id) {
              var oField = this.fieldsHash[f.field_id];
              if (oField) {
                questionIndex += 1;
                delete this.fieldsHash[f.field_id]['question_seq'];
                this.fieldsHash[f.field_id]['question_seq'] = questionIndex;
              }
            }
          })
        }
        _.each(this.configuration.fields, (field) => {
          if (field && field.field_id) {
            if (field.field_id == 'primary_rating') {
              primaryRatingSet = true;
            }
            if (field.field_id == 'comments') {
              primaryCommentSet = true;
            }
          }
          delete field['seq_no'];
        })
      } catch (e) { }
    }
    return {
      "primary_rating_set": primaryRatingSet,
      "primary_comment_set": primaryCommentSet
    }
  }

  handleMultiSelectForGroups() {
    _.each(this.configuration.fields, (field) => {
      if (field.group_id) {
        field.dynamic_properties = this.getQuestionByFieldId(field.group_id).dynamic_properties;
      }
    });
  }
  getQuestionByFieldId(fieldId) {
    if (fieldId)
      return this.fieldsHash[fieldId.toString()];
    return
  }

  handleMultiSelectQuestion() {
    if (this.configuration.screens) {
      _.each(this.devices, (deviceId) => {
        if (this.configuration.screens[deviceId]) {
          var pages = this.configuration.screens[deviceId][this.default_language.toString()];
          if (pages && pages.length > 0) {
            _.each(pages, (page) => {
              if (page && page.fields && page.fields.length > 0) {
                if (!page.is_rating_page) {
                  delete page["rating_button_label"];
                  delete page["rating_back_button_label"];
                }
                if (page.save_on_submit == null || typeof page.save_on_submit == undefined) {
                  page.save_on_submit = true;
                } else {
                  page.do_not_save_on_submit = !page.save_on_submit;
                }
                if (page.enable_auto_scroll == null || typeof page.enable_auto_scroll == undefined) {
                  page.enable_auto_scroll = true;
                } else {
                  page.disable_auto_scroll = !page.enable_auto_scroll;
                }
                var tmpPageFields: any = [];
                _.each(page.fields, (field, index) => {

                  if (field && field.field_id && !field.is_wheel_label && !(field.is_deleted)) {
                    var allowedMultiSelect = (field["allowMultiSelect"] || field.params["allowMultiSelect"]);
                    if (!allowedMultiSelect && !field.group_id && field.question_component_type != 'ltms-multi-check-box' && !field.is_wheel_label) {
                      tmpPageFields.push(field);
                    } else {
                      if (!field.group_id && allowedMultiSelect) {
                        var subQuestions = this.getFieldsByGroupId(field.field_id);
                        if (subQuestions && subQuestions.length > 0) {
                          subQuestions = subQuestions.map((obj) => {
                            var subQuestion: any = {
                              "group_id": obj.group_id,
                              "field_id": obj.field_id,
                              "component_type": obj.component_type,
                              "type": field.type,
                              "conditional_label": obj.conditionalLabel
                            }

                            /**
                             * Fix the bug for setup options for moms - new component
                             * handle_inline_block:true This key is added for multi option multi select - new component
                             * group details because the rendering DOM is different 
                            */
                            if (subQuestion.component_type === "ltms-multi-select") {
                              subQuestion['handle_inline_block'] = true;
                            }

                            subQuestion['enable_shuffle'] = (field['enable_shuffle'] && obj['enable_shuffle']) ? true : false;
                            if (obj['visible-if']) {
                              subQuestion['visible-if'] = obj['visible-if']
                            }
                            if (obj['server-visible-if']) {
                              subQuestion['server-visible-if'] = obj['server-visible-if']
                            }
                            subQuestion.params = Helpers.deepClone(field.params);
                            subQuestion.params.options = Helpers.deepClone(obj.params.options);
                            this.handleDependantConditions(field, subQuestion)
                            subQuestion['interaction_type'] = 'multi-select';

                            /**
                            * Fix the bug for setup options for moms - new component
                            * handle_inline_block:true This key is added for multi option multi select - new componen                                                                * handle_inline_block:true This key is added for multi option multi select - new component
                            * group details because the rendering DOM is different 
                            */
                            var index1 = this.getFieldIndex(subQuestion.field_id);
                            if (index1 >= 0) {
                              this.configuration.fields[index1]['is_mandatory_if'] = subQuestion['is_mandatory_if'];
                              this.configuration.fields[index1]['server-visible-if'] = subQuestion['server-visible-if'];
                              this.configuration.fields[index1]['visible-if'] = subQuestion['visible-if'];
                              if (this.configuration.fields[index1].component_type && this.configuration.fields[index1].component_type == "ltms-multi-select") {
                                this.configuration.fields[index1]['handle_inline_block'] = true;
                              }
                            }
                            // cnvdr.fieldsHash[subQuestion.field_id]['is_mandatory_if'] = subQuestion['is_mandatory_if'];
                            // cnvdr.fieldsHash[subQuestion.field_id]['server-visible-if'] = subQuestion['server-visible-if'];
                            // cnvdr.fieldsHash[subQuestion.field_id]['visible-if'] = subQuestion['visible-if'];

                            return subQuestion;
                          });
                          tmpPageFields.push(field);
                          tmpPageFields.splice.apply(tmpPageFields, [tmpPageFields.length, 0].concat(subQuestions));
                        }
                      }
                    }
                  }
                })
                page.fields = tmpPageFields;
              }
            })
          }
        }
      })
    }
  }

  handleBarReactorQuestion() {
    // cnvdr.question.component.rating_bar_reactor_allowed
    if (this.configuration.screens) {
      _.each(this.devices, (deviceId) => {
        if (this.configuration.screens[deviceId]) {
          var pages = this.configuration.screens[deviceId][this.default_language.toString()];
          if (pages && pages.length > 0) {
            _.each(pages, (page) => {
              if (page && page.fields && page.fields.length > 0) {
                var tmpPageFields: any = [];
                // sequence no. will be used on dashboard
                _.each(page.fields, (field, index) => {
                  if (field && field.field_id && !(field.is_deleted)) {
                    var tmpField = this.fieldsHash[field.field_id];
                    if ((field.component_type.indexOf('wheel') >= 0 || field.has_reactor) && !tmpField.hide_label) {
                      var labelFieldForWheelQuestion = {
                        "component_type": "litmus-text-label",
                        "label": field.label ? field.label : tmpField.label,
                        "is_wheel_label": true,
                        "read-only": true,
                        "params": {
                          "className": "litmus-wheel-label"
                        }
                      }
                      this.handleDependantConditions(field, labelFieldForWheelQuestion);
                      tmpPageFields.push(labelFieldForWheelQuestion);
                    }

                    if (tmpField && tmpField.component_type) {
                      // Bug fix - By Bhunesh - 2nd Feb 2017 - Bar ractor at multiple places
                      var isReactorComponent = this.isReactorComponent(tmpField.component_type);
                      if (tmpField && !tmpField.rating_bar_reactor_allowed && !isReactorComponent && !tmpField.is_wheel_label) {
                        tmpPageFields.push(field);
                      } else {
                        if (tmpField && !isReactorComponent && !tmpField.is_wheel_label && tmpField.rating_bar_reactor_allowed) {
                          var barReactor = this.generateBarReactor(field.field_id, field.params, field.component_type, tmpField.reactor_type);
                          this.handleDependantConditions(field, barReactor);
                          if (field.has_reactor == true) {
                            delete field['label'];
                          }
                          if (barReactor) {
                            tmpPageFields.push(barReactor);
                          }
                          tmpPageFields.push(field);
                        }
                      }
                    }

                  }
                })
                page.fields = tmpPageFields;
              }
            })
          }
        }
      })
    }
  }


  isReactorComponent(component) {
    return (this.reactorComponents.indexOf(component) >= 0) ? true : false;
  }

  generateBarReactor(fieldId, params, componentType, reactorType) {
    var configuration = this.getBarReactorConfiguration(params, componentType);
    if (configuration && configuration.prop && configuration.colors) {
      var barReactorField = {
        "field_id": this.generateId('bar_reactor') + Helpers.getRandomString(),
        "component_type": reactorType ? reactorType : "ltms-rating-bubble-reactor",
        "listen_field_id": fieldId,
        "read-only": true,
        "params": {
          "listen_field_id": fieldId,
          "configuration": (configuration && configuration.prop) ? configuration.prop : null,
          "rater_type": (configuration && configuration.rater_type) ? configuration.rater_type : null,
          "colors": configuration.colors,
          "fourScale": params.fourScale
        }
      }
      return barReactorField;
    }
    return;
  }

  getBarReactorConfiguration(params, componentType) {
    if (params.configuration && params.configuration.length > 0) {
      var params = Helpers.deepClone(params);
      var configuration: any = { "colors": [], "prop": {}, "rater_type": "litmus" };
      var propertyNames = this.getPropertiesForBarReactor(componentType);
      if (propertyNames && propertyNames.rater_type) {
        configuration['rater_type'] = propertyNames.rater_type;
      }
      _.each(params.configuration, function (config, index) {
        if (index == 0) {
          configuration["prop"]["default"] = {
            "label": params._ltmsLabelDefaultMessage,
            "color": "#000"
          }
        }
        configuration["prop"][config.value.toString()] = {
          "label": config._ltmsLabelMessage,
          "color": config.color
        }
        configuration.colors.push(config.color)
      })
      return configuration;
    }
    return;
  }


  getPropertiesForBarReactor(componentType) {
    if (componentType.indexOf('-five-point') >= 0) {
      return {
        rater_type: "detailed_rater",
        color_property: "litmus_gradient_deatiled_rating_color"
      }
    } else if (componentType.indexOf('nps') >= 0) {
      return {
        rater_type: "nps",
        color_property: "nps_gradient_color"
      }
    } else if (componentType.indexOf('wheel') >= 0 || componentType.indexOf('ltms-slider-rater') >= 0) {
      return {
        rater_type: "litmus",
        color_property: "litmus_gradient_positive_color"
      }
    } else {
      return {
        rater_type: "detailed_rater",
        color_property: "litmus_gradient_deatiled_rating_color"
      }
    }
    return;
  }

  removeDeletedQuestions() {
    this.configuration.fields = _.filter(this.configuration.fields, (f) => {
      if (f.is_deleted) {
        delete this.fieldsHash[f.field_id];
      }
      return !(f.is_deleted || f.component_type == null);
    });
  }

  // Added by Bhunesh - Feb 12 2017 - handlePages() To handle if pageid is exist in flow but not defined in screens
  handlePages(isPublish) {
    // Added by Bhunesh - Feb 17 2017 - Save Page view details for dashboard analytics usage
    var pageViewDetails: any = [];
    var pageHash: any = {};
    _.each(this.devices, (device) => {
      try {
        var groups = this.configuration["flows"][device.toString()][this.default_language];
        // filter pages which are defined on screens
        groups = _.filter(groups, (group) => {
          var page = this.getPageDetailById(group, device);
          if (page) {
            pageHash[page.id] = page;
          }
          return !!page;
        });
        if (isPublish) {
          // saving page view details
          _.each(groups, (group, index) => {
            if (pageHash[group]) {
              pageViewDetails.push({
                "page_name": pageHash[group].id,
                "device": device,
                "display_name": pageHash[group].page_title,
                "page_sequence": index + 1
              })
            }
          });
        }
        this.configuration["flows"][device.toString()][this.default_language] = groups;
      } catch (e) {
        console.error("Error: Conversation Designer: handlePages()", e);
      }
    })
    if (pageViewDetails && pageViewDetails.length > 0) {
      this.configuration.page_view_details = pageViewDetails;
    }
  }

  getPageDetailById(pageId, deviceId) {
    try {
      if (this.configuration["screens"][deviceId.toString()] && this.configuration["screens"][deviceId.toString()][this.default_language]) {
        return _.find(this.configuration["screens"][deviceId.toString()][this.default_language], { id: pageId });
      }
    } catch (e) {
      console.error("Error: Conversation Designer: getPageDetailById()", e);
      return null;
    }

  }

  /**
   * [updateLabelsForAllLanguage - Update labels for all language]
   * Added by Bhunesh 21th Feb 2017 
   */
  updateLabelsForAllLanguage() {
    try {
      var languagesList = Object.keys(this.configuration.languages);
      if (languagesList && languagesList.length > 1) {
        _.each(languagesList, (language) => {
          this.getAllLabelsForSelectedLanguage(language);
        })
      }
    } catch (e) {
      console.error("Error: Conversation Designer: updateLabelsForAllLanguage()", e);
    }
  }

  getAllLabelsForSelectedLanguage(language: any, isUi?: any) {
    this.language = language;
    try {
      for (var labelId in this.configuration.languages[this.default_language]['labels']) {
        if (!this.configuration.languages[language]['labels'][labelId]) {
          this.configuration.languages[language]['labels'][labelId] = this.configuration.languages[this.default_language]['labels'][labelId];
        }
      }
    } catch (e) {
      console.error("Error: Conversation Designer: getAllLabelsForSelectedLanguage()", e);
    }
    // Added fake loading overalay
    if (isUi) {
      setTimeout(() => {
        this.labelsRetrieved = true;
      }, 500)
    }
  };

  publishConversation(isPublish, requestFrom) {
    return new Promise((resolve, reject) => {
      var validated = this.validateLastInteraction();
      if (validated) {
        this.configuration.is_new_component_editor = true;
        // Update question sequence
        if (isPublish) {
          ltmsConversationDefaultProps.updatePageSequenceForFields(this.configuration, this.default_language);
        }
        // Merge default conversation with the newly created interaction
        this.mergeConfig(() => {
          this.updateMultiSelectQuestions();

          let fields = Helpers.deepClone(this.configuration.fields);
          let promises: any = [];
          _.each(fields, (field: any) => {
            if (field) {
              promises.push(this.getUpdatedFields(field));
            }
          })
          Promise.all(promises).then((updatedFields) => {
            const updatedFieldsHash = _.keyBy(updatedFields, 'field_id');
            let screens = Helpers.deepClone(this.configuration.screens);
            let updatedScreens = this.processScreenForUpdatedFields(screens, updatedFieldsHash);
            this.configuration.screens = updatedScreens;
            // console.log("this.configuration", Helpers.deepClone(this.configuration))
            if (this.configData && this.configData.reference_version && this.configData.reference_version != '') {
              this.configuration["reference_version"] = _.get(this.configData, 'reference_version');
              this.configuration['created_by'] = _.get(this.configData, 'created_by');
              this.configuration['created_by_email_address'] = _.get(this.configData, 'created_by_email_address');
            }
            this._settingsService.updateQuestionnaire(this.brandId, this.configuration, isPublish).subscribe((response) => {
              this.conversationPublishing = false;
              this.interactionSaving = false;
              this.conversationSaving = false;
              this.savingAdvanceSettings = false;
              if (!response.error) {
                if (response.code == 403) {
                  Helpers.showAuthorizationErr();
                  resolve(false);
                } else if (response.code == 0) {
                  if (this.lastSelectedInteractionId) {
                    if (!(requestFrom == "Interaction Removed")) {
                      this.question = {};
                      //cnvdr.getInteractionDetail(lastSelectedInteractionId);
                    } else {
                      this.fieldsHash[this.lastSelectedInteractionId] = null;
                      this.lastSelectedInteractionId = null;
                    }
                  }
                  var messageText = isPublish ? "Conversation Published" : "Conversation Saved";
                  if (requestFrom && requestFrom != "header" && requestFrom != "footer" && requestFrom != "navigation") {
                    messageText = requestFrom;
                  }
                  Helpers.smallAlertBox("Success", messageText + " Successfully", "success", 2000);
                  this.getConfiguration(this.brand_detail._id, isPublish).then((response) => {
                    resolve(response);
                  })
                } else {
                  Helpers.smallAlertBox("Error", "Something went wrong", "error", 2000);
                  resolve(false);
                }
              } else {
                Helpers.smallAlertBox("Error", "Something went wrong", "error", 2000);
                resolve(false);
              }

            })
          })



        });
      } else {
        this.removeAllProgress()
        resolve(false);
      }

    })

  }


  /**
   * mergeConfig: Method to merge default conversation(Thank you page, Archieve page and Link expiry page) with first interaction creation configuration
   */
  mergeConfig(cb) {
    // If defaultConversation is not empty
    if (!_.isEmpty(this.defaultConversation)) {
      Helpers.showConfirmationBox("Default Questions & Pages", "The following Questions and Pages can automatically be added to your Project<br>• Thank you for responding<br>• Response already received<br>• Link has expired<br>We recommend adding them now. If you chose not to add them now, they will have to be created manually.<br>Do you wish to create them now?", (answer) => {
        if (answer) {
          // labelsToMergeWith will contains defaultConversation labels
          var labelsToMergeWith = _.get(this.defaultConversation, "languages." + this.default_language + ".labels");
          // labelsToMergeFrom will contains cnvdr.configuration's labels
          var labelsToMergeFrom = _.get(this, "configuration.languages." + this.default_language + ".labels");

          // interactionsToMerge will contains cnvdr.configuration's fields
          var interactionsToMerge = _.get(this, "configuration.fields");

          if (!_.isEmpty(labelsToMergeWith) && !_.isEmpty(labelsToMergeFrom)) {
            // Merge new interaction labels in the default conversation labels
            _.each(labelsToMergeFrom, (value, key) => {
              this.defaultConversation["languages"][this.default_language]["labels"][key] = labelsToMergeFrom[key];
            });
          }

          // Merge 'fields' of defaultConversation and configuration and kept into defaultConversation
          Array.prototype.push.apply(this.defaultConversation["fields"], interactionsToMerge);
          this.configuration = this.defaultConversation;
        }
        this.conversationGuidedTour();
        cb();
      });
    } else {
      this.conversationGuidedTour();
      cb();
    }
  }

  updateMultiSelectQuestions() {

    if (this.configuration && this.configuration.fields) {
      var groupStatus = {};

      _.each(this.configuration.fields, (field) => {

        if (field && field.component_id && field.sub_questions && field.field_id && field.interaction_type) {
          if (field.question_component_type && field.question_component_type === 'ltms-multi-check-box' && field.sub_questions) {
            groupStatus[field.field_id] = field.interaction_type;
          }
        }
      });

      _.each(this.configuration.fields, (field) => {
        if (field && field.group_id && field.interaction_type && field.component_type) {
          if (groupStatus[field.group_id]) {
            field.interaction_type = groupStatus[field.group_id];
          }

          if (field.labelId && field.params && field.interaction_type && field.interaction_type === 'multi-select') {
            var tempObj = {
              "title": field.labelId
            };
            if (field.value) {
              tempObj['value'] = field.value;
            }

            field.params.options = [tempObj]
          }
        }
      });
    }
  }

  conversationGuidedTour() {

    this.is_tour_enabled = false;
    // uncomment below code if required
    // let tempObj: any = localStorage.getItem("LOGIN_RESPONSE")
    // var response = (localStorage.getItem("LOGIN_RESPONSE")) ? JSON.parse(tempObj) : {};
    // if (this.configuration && this.configuration.fields && this.configuration.fields.length > 0 && FetchGuidedStats.isGuidedKeyEnabled) {
    //   setTimeout((){
    //     this.is_tour_enabled = true;
    //   }, 10);
    //   if (Helpers.isSelfServiceUser() && response.manager.guided_tour['project']['conversation_new']) {
    //     angularTourService.prepareGuidedTourData('conversation_ss_rest', cnvdr);  //(ss user => pages )
    //   } else if (!response.manager.guided_tour['project']['conversation_new'] && !response.manager.guided_tour['project']['conversation']) {
    //     angularTourService.prepareGuidedTourData('conversation', cnvdr);    //(old conversation tab)
    //   } else if (Helpers.isSelfServiceUser() && !response.manager.guided_tour['project']['conversation_new']) {
    //     angularTourService.prepareGuidedTourData('conversation_ss_all', cnvdr);    //(old conversation tab)
    //   } else if (response.manager.guided_tour['project']['conversation_new'] && !response.manager.guided_tour['project']['conversation']) {
    //     angularTourService.prepareGuidedTourData('conversation_rest', cnvdr); //(normal user => pages )
    //   }
    // } else if (this.configuration && this.configuration.fields && this.configuration.fields.length == 0 && FetchGuidedStats.isGuidedKeyEnabled && !response.manager.guided_tour['project']['conversation']) {
    //   setTimeout( () {
    //     this.is_tour_enabled = true;
    //   }, 10);
    //   angularTourService.prepareGuidedTourData('conversation_new', cnvdr); //true
    // }
  }

  getConfiguration(brand_id, isPublish) {
    return new Promise((resolve, reject) => {
      this._settingsService.getFeedbackConfiguration(brand_id).subscribe((response: any) => {
        if (response && response?.data?.code == 0 && _.has(response, 'data.brand_configuration')) {
          this.configuration = response.data.brand_configuration[0] || {}
          this.init(this.brand_detail, this.configuration).then(() => {
            this.configurationLoaded = true
            resolve(true);
          })
        } else {
          resolve(false);
        }
      })
    })

  }

  // removeAllProgress() - Added by Bhunesh - 15th March 2017
  // - Removing all the Progress 
  removeAllProgress() {
    this.conversationSaving = this.conversationPublishing = this.interactionSaving = this.savingAdvanceSettings = false;
    // try {
    //     showLoading(false);
    // }
    // catch (e) { }
  }


  validateHeaderFooterLogo() {
    var checkForHeader = (this.configuration.header && this.configuration.header.enableHeaderLogo && !this.configuration.header.headerLogoUrl);
    var checkForFooter = (this.configuration.footer && this.configuration.footer.showLogoInFooter && !this.configuration.footer.footerLogoUrl);
    if (checkForHeader && checkForFooter) {
      this.dynamicMessage("Header and Footer");
      return false;
    } else if (checkForHeader) {
      this.dynamicMessage("Header");
      return false;
    } else if (checkForFooter) {
      this.dynamicMessage("Footer");
      return false;
    }
    return true;
  }

  dynamicMessage(tabName) {
    Helpers.smallAlertBox("Brand logo not uploaded in the " + tabName + "", "Please upload the logo and then click on Save", "error", 5000);
    const outerContainer: any = document.getElementById('conversationsOuterContainer');
    if (outerContainer)
      outerContainer.classList.remove("wait");

    const tabsContainer: any = document.getElementById('conversationTabsContainer');
    if (tabsContainer)
      tabsContainer.classList.remove("screen-busy");

  }

  validateLastInteraction(event?: any) {
    var validated: boolean = false;
    var errors: any = "";
    if (this.lastSelectedInteractionId) {
      var lastInteraction = this.fieldsHash[this.lastSelectedInteractionId];
      if (lastInteraction && !lastInteraction.is_deleted) {
        if (!(lastInteraction["component_type"] && lastInteraction["component_id"])) {
          errors += "<b>'Display as'</b> is required field<br>";
        }
        if (!lastInteraction["conversation_type"]) {
          errors += "<b>'Type'</b> is required field<br>";
        }
        if (!(lastInteraction["text"] && (lastInteraction["text"]).trim().length > 0)) {
          errors += "<b>'Text'</b> is required field<br>";
        }
      }
    }
    if (errors && errors.trim().length > 0) {
      Helpers.smallAlertBox("Error", errors, "error", 2000);
    } else {
      validated = true;
    }
    if (event && !validated) {
      event.preventDefault();
      event.stopPropagation();
    }
    return validated;
  }


  getParamsForMQL(params) {
    return new Promise((resolve: any) => {
      var labelsDictionary = this.configuration.languages[this.default_language]['labels'];
      var mqlParams = null;
      this._encoderService.getEncodedConfiguration(params, labelsDictionary, '_ltmsLabel', (updatedParams) => {
        if (updatedParams.configuration && updatedParams.labelsDictionary) {
          this.configuration.languages[this.default_language]['labels'] = updatedParams.labelsDictionary;
          mqlParams = JSON.parse(JSON.stringify(updatedParams.configuration));
        }
        resolve(mqlParams);
      });
    })
  };

  updateComponentPropertiesIntoScreens(updatedField: any) {
    var language = this.default_language;
    if (this.configuration.screens) {
      _.each(this.devices, (deviceId) => {
        if (this.configuration.screens[deviceId]) {
          var pages = this.configuration.screens[deviceId][language.toString()];
          if (pages && pages.length > 0) {
            _.each(pages, (page) => {
              if (page && page.fields && page.fields.length > 0) {
                _.each(page.fields, (field, index) => {
                  if (field && field.field_id) {
                    if ((field.field_id == updatedField.field_id) || (this.lastSelectedInteractionId && field.field_id == this.lastSelectedInteractionId)) {
                      page.fields[index] = updatedField;
                    }
                  }
                })
              }
            })
          }
        }
      });
    }
  }

  getParamsConfiguration(interaction: any, cb: any) {
    cb(interaction?.params?.configuration)
  }

  setDashboardProperties(interaction: any) {
    this.getParamsConfiguration(interaction, (configuration: any) => {
      interaction.possible_values = [];
      interaction.prop = {};
      if (configuration && configuration.length > 0) {
        var colors = Helpers.generateColor("#BBDEFB", "#0D47A1", configuration.length);
        _.each(configuration, (config, index) => {
          if (config && !_.isEmpty(config)) {
            if (config.value != null) {
              interaction.possible_values.push(config.value);
              var color = config.active_color ? config.active_color : config.color;
              interaction.prop[config.value.toString()] = {
                "value": config.value,
                "label": this.getLabelFieldValue(config),
                "active_color": color ? color : '#' + colors[index]
              }
            }
          }
        })
      }
    });
  }

  getLabelFieldValue(object) {
    for (var c in object) {
      if (c && c.indexOf('_ltmsLabel') >= 0) {
        return object[c];
      }
    }
    return;
  }

  updateChildInteractions(interaction) {
    if (interaction.params) {
      interaction.params.options = [];
    }
    if (interaction.sub_questions && interaction.sub_questions.length > 0) {

      interaction.possible_values = [];
      interaction.prop = {};

      if (interaction.allowMultiSelect) {
        delete interaction['params']['options'];
      }
      var colors = Helpers.generateColor("#BBDEFB", "#0D47A1", interaction.sub_questions.length);
      _.each(interaction.sub_questions, (subQuestion, index) => {
        if (subQuestion && subQuestion.field_id && subQuestion.value) {
          this.handleDependantConditions(interaction, subQuestion);
          // properties for dashboard
          interaction.prop[subQuestion.value.toString()] = {
            "value": subQuestion.value,
            "active_color": '#' + colors[index],
            "label": subQuestion.text,
            "linked_field_id": subQuestion.linked_field_id
          };
          // adding possible values
          interaction.possible_values.push(subQuestion.value);

          var existingLabelForText = this.getPropertyNameForText(this.default_language, subQuestion.text);

          if (existingLabelForText) {
            subQuestion.labelId = existingLabelForText;
          } else {
            // Label does not exist in dictionary with the option text
            // generating new label Id and adding into language labels dictionary
            var labelId = this.generateId('label') + Helpers.getRandomString();
            subQuestion.labelId = labelId;
            this.setLabelById(this.default_language, subQuestion.labelId, subQuestion.text);
          }

          if (subQuestion.conditionalLabel && Object.keys(subQuestion.conditionalLabel).length) {
            var oldLabelId = Object.keys(subQuestion.conditionalLabel)[0];
            var conditionalLabels = subQuestion.conditionalLabel[oldLabelId];
            subQuestion.conditionalLabel[subQuestion.labelId] = conditionalLabels;
            /** 
             * If more than one key is there (sub question case) then it could be the 
             * old one need to remove that from conditional label object
             */
            if (Object.keys(subQuestion.conditionalLabel).length > 1) {
              delete subQuestion.conditionalLabel[oldLabelId];
            }

            /** Multilingual support for conditional label */
            _.each(subQuestion.conditionalLabel[subQuestion.labelId], (label, idx) => {
              var labelText = this.getPropertyNameForText(this.default_language, label.text);

              if (labelText) {
                label.labelId = labelText;
              } else {
                var labelId = this.generateId('label') + Helpers.getRandomString();
                label.labelId = labelId;
                this.setLabelById(this.default_language, labelId, label.text);
              }
            });
          }

          subQuestion.params = Helpers._objectWithoutProperties(interaction.params, ["options"]);

          subQuestion.question = subQuestion.text;

          subQuestion.component_type = interaction.component_type;

          subQuestion.type = "detailed-rating";

          var option = {
            "title": subQuestion.labelId,
            "value": subQuestion.value
          }
          if (interaction.allowMultiSelect) {
            subQuestion.interaction_type = "multi-select";
            subQuestion.params.options = [option];
            var index = this.getFieldIndex(subQuestion.field_id);
            subQuestion.prop = {}
            subQuestion.prop[option.value] = {
              "label": subQuestion.text,
              "value": subQuestion.value
            }
            //Added possible_values for subQuestion in multi option multi select component.
            subQuestion.possible_values = [subQuestion.value];
            if (index >= 0) {
              this.configuration.fields[index] = subQuestion;
            } else {
              this.fieldsHash[subQuestion.field_id] = subQuestion;
              this.configuration.fields.push(subQuestion);
            }
          } else {
            interaction.params["options"].push(option);
          }
        }

      })
      if (interaction.allowMultiSelect) {
        // generateMandetoryIf(cnvdr.getFieldsByGroupId(interaction.field_id), interaction);
        interaction['component_type'] = "litmus-text-label";
      }
    }
  }

  getFieldIndex(fieldId) {
    return _.findIndex(this.configuration.fields, { "field_id": fieldId })
  }

  /**
   * function handleDependantConditions
   * Description - Copy or remove display/mandatory conditions on dependant question
   */
  handleDependantConditions(srcField, childField) {
    try {
      childField.do_not_repeat = srcField.do_not_repeat;
      if (srcField['visible-if']) {
        if (childField['visible-if'] && !_.isEmpty(childField['visible-if'])) {

          var parentVisibleIf = '(' + srcField['visible-if'] + ')';
          if (childField['visible-if'].indexOf(parentVisibleIf) === -1) {
            /** 
             * Added double bracket open & close for differentating child and parent condition 
             * Only added in visible-if, because in server-if we are not generating logic string
             * and in sub question we are not handiling "is_mandatory_if", that's why "((" is 
             * not there
            */
            childField['visible-if'] = '((' + childField['visible-if'] + '))&&(' + srcField['visible-if'] + ')';
          }
        } else {
          childField['visible-if'] = '(' + srcField['visible-if'] + ')';
          // childField['visible-if'] = srcField['visible-if'];
        }
      } else {
        // delete childField['visible-if'];
      }
      if (srcField['is_mandatory_if']) {
        childField['is_mandatory_if'] = srcField['is_mandatory_if'];
      } else {
        delete childField['is_mandatory_if'];
      }
      if (srcField['server-visible-if']) {
        if (childField['server-visible-if'] && !_.isEmpty(childField['server-visible-if'])) {
          var parentServerVisibleIf = '(' + srcField['server-visible-if'] + ')';
          if (childField['server-visible-if'].indexOf(parentServerVisibleIf) === -1) {
            childField['server-visible-if'] += '&&(' + srcField['server-visible-if'] + ')';
          }
        } else {
          childField['server-visible-if'] = '(' + srcField['server-visible-if'] + ')';
        }
      } else {
        // delete childField['server-visible-if'];
      }
    } catch (e: any) {
      console.error("Error:handleDependantConditions()", e.toString());
    }
  }

  getFieldsByGroupId(groupId) {
    var group = _.filter(this.configuration.fields, (field: any) => {
      return (field.field_id == groupId && !(field.is_deleted))
    });

    var list: any = []
    if (group && group.length && group[0].possible_values) {
      var options = group[0].possible_values;

      options.forEach((op) => {
        var sortedOption: any = _.filter(this.configuration.fields, function (field) {
          return (field.group_id == groupId && !(field.is_deleted) && op == field.value)
        });
        list.push(sortedOption[0])

      });
    }
    return list;

  }

  get(): any {
    return this.conversationObject;
  }

  set(configuration: any): void {
    // this.conversation = conversation;
    this.conversationObject.update(current => ({ ...current, configuration: configuration }));
  }

  removeFile(query: {}): void {
    // Implementation for removing file 
    if (query && !_.isEmpty(query)) {
      const index = _.findIndex(this.tempFileObjects, query);
      if (index != -1) {
        this.tempFileObjects.splice(index, 1);
      }
    }
  }

  saveConfiguration(isPublish) {
    return new Promise((resolve, reject) => {
      var __isPublish = isPublish;
      this.savingAdvanceSettings = false;
      this.configuration['google_analytics_code'] = this.customConfig.googleAnalyticsCode;

      this.uploadAndSaveData(__isPublish)
        .then((_response) => {
          // $scope.$parent.enableLoader(false);
          resolve({
            success: true,
            isPublish: __isPublish
          });
        }, function (error) {
          resolve({
            success: false,
            isPublish: __isPublish
          });
        });
    });
  }


  uploadAndSaveData(isPublish) {
    return new Promise((resolve, reject) => {
      if (this.customConfig.css.length !== 0 || this.customConfig.javascript.length !== 0) {
        var uploadRequest = this.uploadCustomFiles();
        uploadRequest.then((response: any) => {
          this.savingAdvanceSettings = true;
          if (response) {
            if (response[0]) {
              if (response[0].success && response[0].hasOwnProperty('type')) {
                var _key0 = this.checkFileTypeObject(response[0].type);
                this.files[_key0.remote] = response[0].url ? [response[0].url] : [];
              } else {
                Helpers.smallAlertBox("Error", response[0].error, "error", 12000);
              }
            }

            if (response[1]) {
              if (response[1].success && response[1].hasOwnProperty('type')) {
                var _key1 = this.checkFileTypeObject(response[1].type);
                this.files[_key1.remote] = response[1].url ? [response[1].url] : [];
              } else {
                Helpers.smallAlertBox("Error", response[1].error, "error", 12000);
              }
            }

            this.customConfigUrl = {
              css: this.files['cssFiles'],
              javascript: this.files['jsFiles']
            };

            this.customConfig.css = []
            this.customConfig.javascript = [];

            // ConversationService.set(conversationObject);
            // conversationObject.saveConversation(isPublish);
          }
          resolve(true);
        }, function (error) {
          console.warn(error);
          resolve(false);
        });
      } else {
        if (this.customConfig.googleAnalyticsCode) {
          this.savingAdvanceSettings = true;
        }
        // ConversationService.set(conversationObject);
        // conversationObject.saveConversation(isPublish);
        resolve(true);
      }
    });
  }

  setFile(file) {
    this.tempFileObjects.push(file);
  }

  getFiles() {
    return this.tempFileObjects;
  }

  /**
   * Will return the local and remote key for mapping the data
   * @param {string} type 
   */
  checkFileTypeObject(type) {
    return type === 'css' ? { local: 'css', remote: 'cssFiles', url: 'cssUrl', configPath: 'custom_styles' } : { local: 'javascript', remote: 'jsFiles', url: 'jsUrl', configPath: 'custom_scripts' };
  }

  uploadCustomFiles() {
    return new Promise((resolve, reject) => {
      var brandId = this.brand_detail._id;
      var allPromises: any = [];
      if (this.customConfig.css.length > 0) {
        var _cssRequest = this.upload({
          "data": {
            "brand_id": brandId,
            "file_type": 'css'
          },
          "file_data": this.customConfig.css[0],
          "url": this._utils.apiUrlGeneration(environment.webPrivateV1, '/uploaders/upload')
        }, 'css');
        allPromises.push(_cssRequest);
      }
      if (this.customConfig.javascript.length > 0) {
        var _javascriptRequest = this.upload({
          "data": {
            "brand_id": brandId,
            "file_type": 'js'
          },
          "file_data": this.customConfig.javascript[0],
          "url": this._utils.apiUrlGeneration(environment.webPrivateV1, '/uploaders/upload')
        }, 'js');
        allPromises.push(_javascriptRequest);
      }

      Promise.all(allPromises).then(function (data) {
        resolve(data);
      }, function (error) {
        reject(error);
      });
    });
  }

  upload(params, type) {
    return new Promise((resolve, reject) => {
      Helpers.uploadFile(params, this._utils, 'file_name', function (url, err) {
        if (url && !err) {
          resolve({ success: true, type: type, url: url });
        } else {
          resolve({ success: false, type: type, error: err.error_message });
        }
      });
    });
  }

  uploadFilesInS3(url: string, files: any, type: any) {
    return new Promise((resolve, reject) => {
      var _type = type;

      this._utils.upload(url, {
        file: files[0],
        fileFormDataName: 'brand_images'
      }, this._utils.setHeaderWithParams({ withCredentials: true }), 'POST').subscribe((data, status, headers, config) => {
        resolve({ success: true, type: _type, data: data });
      });
    });
  }

  getPromiseObject(tempFileObject: any, type: any) {
    var url = this._utils.apiUrlGeneration(environment.webPrivateV1, '/upload_brand_images')
    //   var url =  $rootScope.Helpers.getApiUrl('api/upload_brand_images');
    return this.uploadFilesInS3(url, tempFileObject, type);
  }

  invokeRequest(allPromises: any) {
    return new Promise(function (resolve, reject) {
      Promise.all(allPromises).then(function (data) {
        resolve(data);
      }, function (error) {
        reject(error);
      });
    });
  }

  uploadAllFiles(requestFrom: string) {
    return new Promise((resolve, reject) => {
      var allPromises: any = [];
      var fileArray = this.getFiles();
      for (var i = 0; i < fileArray.length; i++) {
        if (requestFrom == fileArray[i].id) {
          allPromises.push(this.getPromiseObject([fileArray[i].file], fileArray[i].id));
        }
      }
      Promise.all(allPromises).then(function (data) {
        resolve(data);
      }, function (error) {
        reject(error);
      });
    });
  }

  getPreviewUrl(isCopy?: boolean) {
    // Changes by Bhunesh - 16th Feb 2017 - removing device parameter in case of copying link
    var configVersion = this.configuration.version;
    var brandId = this.brand_detail._id;
    //Modified - Shigufa - [LP20091724501] Bug - Preview link Url not copied in browser .(For the newly created project)
    var configUrl = (this.brand_detail.conversation_config.feedbacks['url']) ? this.getConfigBaseUrl(this.brand_detail.conversation_config.feedbacks['url'], 'v2/') : environment.base_url;
    var url = configUrl + "preview-v2/" + brandId + "?config=" + configVersion;
    if (isCopy) {
      return url;
    } else {
      // Added by Bhunesh - 3rd Feb 2017 - Preview link URL changes to view preview without publish
      return url + "&device=" + this.previewDevice;
    }
  }

  getConfigBaseUrl(url, text_exclude) {
    return url.replace(text_exclude, '');
  }


  reconfigurePage() {
    let fields = Helpers.deepClone(this.configuration.fields);
    let promises: any = [];
    _.each(fields, (field: any) => {
      if (field) {
        promises.push(this.getUpdatedFields(field));
      }
    })
    Promise.all(promises).then((updatedFields) => {
      const updatedFieldsHash = _.keyBy(updatedFields, 'field_id');
      let screens = Helpers.deepClone(this.configuration.screens);
      let updatedScreens = this.processScreenForUpdatedFields(screens, updatedFieldsHash);
      this.configuration.screens = updatedScreens;
      if (this.configData && this.configData.reference_version && this.configData.reference_version != '') {
        this.configuration["reference_version"] = _.get(this.configData, 'reference_version');
        this.configuration['created_by'] = _.get(this.configData, 'created_by');
        this.configuration['created_by_email_address'] = _.get(this.configData, 'created_by_email_address');
      }

      this._settingsService.updateQuestionnaire(this.brand_detail._id, this.configuration, false).subscribe((response) => {
        this.conversationPublishing = false;
        this.interactionSaving = false;
        this.conversationSaving = false;
        this.savingAdvanceSettings = false;
        if (!response.error) {
          if (response.code == 403) {
            Helpers.showAuthorizationErr();
          } else if (response.code == 0) {
            Helpers.smallAlertBox("Success", "Page Reconfigured Successfully", "success", 2000);
            this.getConfiguration(this.brand_detail._id, false).then((response) => {
              // resolve(response);
            })

          } else {
            Helpers.smallAlertBox("Error", "Something went wrong", "error", 2000);
            // resolve(false);
          }
        } else {
          Helpers.smallAlertBox("Error", "Something went wrong", "error", 2000);
          // resolve(false);
        }

      })

    })
  }

  processScreenForUpdatedFields(screens: any, updatedFieldsHash: any) {
    _.each(screens, (deviceObject: any, deviceKey: string) => {
      _.each(deviceObject, (langObject: any, langKey: string) => {
        if (langObject && !_.isEmpty(langObject)) {
          _.each(langObject, (pageObject: any, pageKey: string) => {
            if (pageObject.fields && !_.isEmpty(pageObject.fields)) {
              _.each(pageObject.fields, (field: any, index: number) => {
                if (updatedFieldsHash[field.field_id] && updatedFieldsHash[field.field_id].params) {
                  field.params = updatedFieldsHash[field.field_id].params;
                }
                screens[deviceKey][langKey][pageKey].fields[index] = field;
              })
            }
          })
        }
      })
    })
    return screens;
  }

  getUpdatedFields(field: any) {
    return new Promise((resolve) => {
      if (field.params) {
        this.getParamsForMQL(field.params).then((params) => {
          field.params = params;
          resolve(field);
        })
      } else {
        resolve(field);
      }
    })
  }

  isUserHasWriteAccess(permissionType: string) {
    let isWriteAccess: boolean = false;
    const adminRulesDic = _.cloneDeep(Helpers?.adminRulesDic || {});
    switch(permissionType) {
      case 'MANAGE_CONVERSATION':
        if (adminRulesDic.CONVERSATION_MANAGE_CONVERSATION && !_.isEmpty(adminRulesDic.CONVERSATION_MANAGE_CONVERSATION) && adminRulesDic.CONVERSATION_MANAGE_CONVERSATION.write) {
          isWriteAccess = true;
        } else {
          isWriteAccess = false;
        }
        break;
      case 'MANAGE_PUBLISH':
        if (adminRulesDic.CONVERSATION_MANAGE_PUBLISH && !_.isEmpty(adminRulesDic.CONVERSATION_MANAGE_PUBLISH) && adminRulesDic.CONVERSATION_MANAGE_PUBLISH.write) {
          isWriteAccess = true;
        } else {
          isWriteAccess = false;
        }
        break;
      default:
        isWriteAccess = false;
        break;
    }
    return isWriteAccess;
  }
}
